import { render, staticRenderFns } from "./honor-panel.vue?vue&type=template&id=bed44e5a"
import script from "./honor-panel.vue?vue&type=script&lang=js"
export * from "./honor-panel.vue?vue&type=script&lang=js"
import style0 from "./honor-panel.vue?vue&type=style&index=0&id=bed44e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports